import { BofSearchResultDto } from '@/api/player-api/api-models'
import { SearchItem, SearchSection, SearchView } from './search.model'

export interface SearchMapperContext {
	/** Matches carry only a sport name, so the id has to be looked up for the icon. */
	sportIdByName: Map<string, number>
	sportImageUrl: (sportId: number) => string
	formatPlayDate: (playDate: string) => string
}

/** Single seam between the API shape and the rendered view — grouping changes belong here. */
export function toSearchView(dto: BofSearchResultDto, context: SearchMapperContext): SearchView {
	const imageUrlForSportName = (sport: string): string => {
		const sportId = context.sportIdByName.get(sport)
		return sportId === undefined ? '' : context.sportImageUrl(sportId)
	}

	const matches: SearchItem[] = (dto.matches ?? []).map((data) => ({
		type: 'match',
		key: `match:${data.matchId}`,
		label: `${data.home} vs ${data.away}`,
		imageUrl: imageUrlForSportName(data.sport),
		isLive: data.live,
		league: [data.category, data.tournament].filter(Boolean).join(' / '),
		startLabel: data.live ? '' : context.formatPlayDate(data.playDate),
		flatIndex: -1,
		data
	}))

	const tournaments: SearchItem[] = (dto.tournaments ?? []).map((data) => ({
		type: 'tournament',
		key: `tournament:${data.tournamentId}`,
		label: data.tournament,
		imageUrl: context.sportImageUrl(data.sportId),
		flatIndex: -1,
		data
	}))

	const sections: SearchSection[] = [
		{ key: 'match', titleKey: 'other.matches', items: matches },
		{ key: 'tournament', titleKey: 'other.tournaments', items: tournaments }
	].filter((section) => section.items.length > 0)

	const flatItems = sections.flatMap((section) => section.items)
	flatItems.forEach((item, index) => {
		item.flatIndex = index
	})

	return { sections, flatItems, totalCount: flatItems.length }
}
